module.exports = __webpack_public_path__ + "static/media/Inter-Medium.5ff1f2a9.ttf";